import {Component, EventEmitter, input, Input, OnInit, Output} from '@angular/core';
import {NgOptimizedImage, NgStyle} from "@angular/common";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-simple-image',
  standalone: true,
  imports: [
    NgOptimizedImage,
    NgStyle
  ],
  templateUrl: './simple-image.component.html',
  styleUrl: './simple-image.component.css'
})
export class SimpleImageComponent {
  data = input<any>();

  constructor() {}

  containerPadding = 56.25;

  onImageLoad(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img.naturalWidth && img.naturalHeight) {
      // Berechne das Padding als (Höhe / Breite) * 100
      this.containerPadding = (img.naturalHeight / img.naturalWidth) * 100;
    }
  }

}
